import React from "react";
import { isDone, isMilestone } from "../utils";
import { Props } from "./types";
import styles from "./styles.scss";

function Progress({ element, progress, children }: Props) {
  return (
    <div className={styles.progress}>
      {children}
      {!isMilestone(element) && !isDone(element) && (
        <div className={styles.bar} style={{ width: `${progress}%` }} />
      )}
    </div>
  );
}

export { Progress };
